import React, { useState } from "react";
import CommonApi from "../../Api/CommonApi";
import { DetectedBoothResponse } from "../../Models/DetectedBooth";

export default function FloorplanUploader({
  onUploaded,
}: {
  onUploaded: (url: string, suggestedBooths?: DetectedBoothResponse[]) => void;
}) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);
      setError(null);
      const res = await CommonApi.uploadFloorplan(formData);
      const data = res.data as {
        url?: string;
        Url?: string;
        suggestedBooths?: DetectedBoothResponse[];
      };
      const url = data.url ?? data.Url;
      if (!url) {
        setError("Upload succeeded but the server did not return an image URL.");
        return;
      }
      onUploaded(url, data.suggestedBooths);
    } catch (err: any) {
      console.error("Floorplan upload failed", err);
      setError(
        err?.response?.data?.message ||
          err?.response?.data ||
          "Upload failed. Use PDF, PNG, or JPG."
      );
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <input
        type="file"
        accept="image/*,.pdf,application/pdf"
        onChange={handleFileChange}
        disabled={uploading}
      />
      {uploading && <p className="text-sm text-gray-600 mt-1">Uploading…</p>}
      {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
      <p className="text-xs text-gray-500 mt-1">
        Upload a clear floorplan (PDF recommended). PDF uploads auto-detect booth
        regions from embedded text when possible.
      </p>
    </div>
  );
}
